export const MainHighRiseMidRiseProjects = {
    "imageUrl": "/assets/imgs/services/4HighRiseMidRiseProjects/fondo.png",
    "eyebrow": "High-Rise & Mid-",
    "title": " Rise Projects",
    "headingSpan": "EXPERTISE",
    "heading": "YOU CAN TRUST",
    "description": "At HRD Painting & Restoration, we specialize in high-rise and mid-rise building restoration, painting, and envelope renewal, ensuring long-lasting protection, structural integrity, and aesthetic appeal. Whether it’s a commercial tower, office building, or multi-unit complex, we deliver expert solutions tailored to the unique challenges of tall structures.",
    "highlightSpan": "The best Building Envelope Renewal",
    "highlight": " / High-Rise Painting & Restoration services.",
    "button": {
        "text": "Request a Quote",
        "url": "/quote"
    }
};